import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

const ItemFormGroupCheckbox = ({
    name,
    label,
    labelKey,
    rules,
    options = [],
    required = false,
    defaultValue = [],
    ...props
}) => {
    const { t } = useTranslation()
    const { control, formState: { errors } } = useFormContext()
    const {
        labelPlacement = "start",
        row = true,
        disabled = false,
        readOnly = false,
        onChangeCustom
    } = props

    const error = get(errors, name)

    const handleChange = (field, value, checked, event) => {
        if (readOnly) return

        const currentValue = Array.isArray(field.value) ? field.value : []
        const nextValue = checked
            ? [...currentValue, value]
            : currentValue.filter((item) => item !== value)

        field.onChange(nextValue)
        onChangeCustom?.(nextValue, event)
    }

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={rules}
            render={({ field }) => {
                const selectedValues = Array.isArray(field.value) ? field.value : []

                return (
                    <FormControlLabel
                        label={labelKey ? t(labelKey) : label}
                        labelPlacement={labelPlacement}
                        required={required}
                        control={
                            <FormControl fullWidth error={!!error} sx={{ flex: 1 }}>
                                <FormGroup
                                    row={row}
                                    sx={{ width: '-webkit-fill-available', flexWrap: row ? 'nowrap' : 'wrap' }}
                                >
                                    {options.map((op) => (
                                        <FormControlLabel
                                            key={op.value}
                                            value={op.value}
                                            control={
                                                <Checkbox
                                                    name={field.name}
                                                    inputRef={field.ref}
                                                    checked={selectedValues.includes(op.value)}
                                                    onBlur={field.onBlur}
                                                    onChange={(event) => {
                                                        handleChange(field, op.value, event.target.checked, event)
                                                    }}
                                                    disabled={disabled || op.disabled}
                                                />
                                            }
                                            label={t(op.label)}
                                            sx={{ '& .MuiFormControlLabel-label': { minWidth: 'unset !important' } }}
                                        />
                                    ))}
                                </FormGroup>
                                {error && <FormHelperText>{t(error.message)}</FormHelperText>}
                            </FormControl>
                        }
                    />
                )
            }}
        />
    )
}

export default ItemFormGroupCheckbox
